import templateUrl from './feedback.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    onFeedbackSubmitted: '&'
  },
  controller: class FeedbackComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onFeedbackSubmitted(
        this.EventEmitter({
          feedback: this.feedback
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/feedback/feedback.component.js